import { useAuth } from "@tellescope/tanstack-query";
import { Button, cn, Label, RadioGroupButtonItem, RadioGroupButtons } from "@tellescope/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export interface InvalidationReasonSelectionProps {
  className?: string;
  onCancel: () => void;
  onInvalidate: (reason: string) => void;
  invalidating: boolean;
}

export const InvalidationReasonSelection = ({
  className,
  onCancel,
  onInvalidate,
  invalidating,
}: InvalidationReasonSelectionProps) => {
  const { selectedOrganization } = useAuth();
  const { t } = useTranslation("vitals");
  const [selectedReason, setSelectedReason] = useState<string>("");
  const reasons = selectedOrganization?.observationInvalidationReasons ?? [];

  return (
    <div className={cn("space-y-2 overflow-hidden", className)}>
      <Label className="text-xs font-medium text-red-500">{t("Reason for invalidation")}</Label>
      <RadioGroupButtons
        value={selectedReason}
        onValueChange={setSelectedReason}
        className="flex-col gap-1"
        unselectedVariant="outline"
        selectedVariant="outline"
      >
        {reasons.map((reason) => (
          <RadioGroupButtonItem
            key={reason}
            value={reason}
            className={cn(
              "justify-start text-xs font-normal",
              selectedReason === reason ? "bg-destructive/10 border-destructive/40 text-destructive" : undefined
            )}
          >
            {reason}
          </RadioGroupButtonItem>
        ))}
      </RadioGroupButtons>
      <div className="flex justify-start items-center gap-2 pt-1">
        <Button
          variant="destructive-secondary"
          className="h-6 text-xs font-normal rounded-md"
          onClick={() => onInvalidate(selectedReason)}
          disabled={!selectedReason}
          loading={invalidating}
        >
          {t("Confirm")}
        </Button>
        <Button
          variant="outline"
          className="h-6 text-xs font-normal rounded-md"
          onClick={() => onCancel()}
          disabled={invalidating}
        >
          {t("Cancel")}
        </Button>
      </div>
    </div>
  );
};
